import { createStore, applyMiddleware, combineReducers } from 'redux';
import thunk from 'redux-thunk';
import authReducer from './Reducers/AuthReducer';
import notificationReducer from './Reducers/NotificationReducer';
import adminInquiryReducer from './Reducers/AdminInquiryReducer';
import assistantReducer from './Reducers/AssistantReducer';

const rootReducer = combineReducers({
  auth: authReducer,
  notifications: notificationReducer,
  adminInquiry: adminInquiryReducer,
  assistants: assistantReducer,
});

const store = createStore(rootReducer, applyMiddleware(thunk));

export default store;

